import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, unref as _unref, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, toDisplayString as _toDisplayString, withModifiers as _withModifiers, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-45827db6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "chart-style-panel" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = {
  key: 1,
  class: "row"
}
const _hoisted_5 = {
  key: 2,
  class: "row"
}
const _hoisted_6 = { class: "row" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"width":"40%"} }, "图例：", -1))
const _hoisted_8 = { class: "row" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"width":"40%"} }, "背景填充：", -1))
const _hoisted_10 = { class: "row" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"width":"40%"} }, "网格颜色：", -1))
const _hoisted_12 = { style: {"width":"40%"} }
const _hoisted_13 = {
  class: "color-btn-wrap",
  style: {"width":"100%"}
}
const _hoisted_14 = ["onClick"]
const _hoisted_15 = { class: "preset-themes" }
const _hoisted_16 = ["onClick", "onMouseenter"]

import { onUnmounted, ref, watch, type Ref } from 'vue'
import { storeToRefs } from 'pinia'
import { useMainStore, useSlidesStore } from '@/store'
import type { ChartData, ChartOptions, PPTChartElement } from '@/types/slides'
import emitter, { EmitterEvents } from '@/utils/emitter'
import useHistorySnapshot from '@/hooks/useHistorySnapshot'

import ElementOutline from '../../common/ElementOutline.vue'
import ColorButton from '../../common/ColorButton.vue'
import ChartDataEditor from './ChartDataEditor.vue'
import ColorPicker from '@/components/ColorPicker/index.vue'
import Modal from '@/components/Modal.vue'
import Divider from '@/components/Divider.vue'
import Checkbox from '@/components/Checkbox.vue'
import Button from '@/components/Button.vue'
import ButtonGroup from '@/components/ButtonGroup.vue'
import Select from '@/components/Select.vue'
import Popover from '@/components/Popover.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const presetChartThemes = [
  ['#d87c7c', '#919e8b', '#d7ab82', '#6e7074', '#61a0a8', '#efa18d'],
  ['#dd6b66', '#759aa0', '#e69d87', '#8dc1a9', '#ea7e53', '#eedd78'],
  ['#516b91', '#59c4e6', '#edafda', '#93b7e3', '#a5e7f0', '#cbb0e3'],
  ['#893448', '#d95850', '#eb8146', '#ffb248', '#f2d643', '#ebdba4'],
  ['#4ea397', '#22c3aa', '#7bd9a5', '#d0648a', '#f58db2', '#f2b3c9'],
  ['#3fb1e3', '#6be6c1', '#626c91', '#a0a7e6', '#c4ebad', '#96dee8'],
  ['#fc97af', '#87f7cf', '#f7f494', '#72ccff', '#f7c5a0', '#d4a4eb'],
  ['#c1232b', '#27727b', '#fcce10', '#e87c25', '#b5c334', '#fe8463'],
  ['#2ec7c9', '#b6a2de', '#5ab1ef', '#ffb980', '#d87a80', '#8d98b3'],
  ['#e01f54', '#001852', '#f5e8c8', '#b8d2c7', '#c6b38e', '#a4d8c2'],
  ['#c12e34', '#e6b600', '#0098d9', '#2b821d', '#005eaa', '#339ca8'],
  ['#8a7ca8', '#e098c7', '#8fd3e8', '#71669e', '#cc70af', '#7cb4cc'],
]

const mainStore = useMainStore()
const slidesStore = useSlidesStore()
const { handleElement, handleElementId } = storeToRefs(mainStore)
const { theme } = storeToRefs(slidesStore)

const handleChartElement = handleElement as Ref<PPTChartElement>

const chartDataEditorVisible = ref(false)
const presetThemesVisible = ref(false)
const presetThemeColorHoverIndex = ref<[number, number]>([-1, -1])

const { addHistorySnapshot } = useHistorySnapshot()

const fill = ref<string>('#000')

const themeColor = ref<string[]>([])
const gridColor = ref('')
const legend = ref('')

const lineSmooth = ref(true)
const showLine = ref(true)
const showArea = ref(false)
const horizontalBars = ref(false)
const donut = ref(false)
const stackBars = ref(false)

watch(handleElement, () => {
  if (!handleElement.value || handleElement.value.type !== 'chart') return
  fill.value = handleElement.value.fill || '#fff'

  if (handleElement.value.options) {
    const {
      lineSmooth: _lineSmooth,
      showLine: _showLine,
      showArea: _showArea,
      horizontalBars: _horizontalBars,
      donut: _donut,
      stackBars: _stackBars,
    } = handleElement.value.options

    lineSmooth.value = !!_lineSmooth
    showLine.value = !!_showLine
    showArea.value = !!_showArea
    horizontalBars.value = !!_horizontalBars
    donut.value = !!_donut
    stackBars.value = !!_stackBars
  }

  themeColor.value = handleElement.value.themeColor
  gridColor.value = handleElement.value.gridColor || '#333'
  legend.value = handleElement.value.legend || ''
}, { deep: true, immediate: true })

const updateElement = (props: Partial<PPTChartElement>) => {
  slidesStore.updateElement({ id: handleElementId.value, props })
  addHistorySnapshot()
}

// 设置图表数据
const updateData = (data: ChartData) => {
  chartDataEditorVisible.value = false
  updateElement({ data })
}

// 设置填充色
const updateFill = (value: string) => {
  updateElement({ fill: value })
}

// 设置其他选项：柱状图转条形图、折线图转面积图、折线图转散点图、饼图转环形图、折线图开关平滑曲线
const updateOptions = (optionProps: ChartOptions) => {
  const _handleElement = handleElement.value as PPTChartElement

  const newOptions = { ..._handleElement.options, ...optionProps }
  updateElement({ options: newOptions })
}

// 设置主题色
const updateTheme = (color: string, index: number) => {
  const props = {
    themeColor: themeColor.value.map((c, i) => i === index ? color : c),
  }
  updateElement(props)
}

// 添加主题色
const addThemeColor = () => {
  const props = {
    themeColor: [...themeColor.value, theme.value.themeColor],
  }
  updateElement(props)
}

// 使用预置主题配色
const applyPresetTheme = (colors: string[], index: number) => {
  const themeColor = colors.slice(0, index + 1)
  updateElement({ themeColor })
  presetThemesVisible.value = false
}

// 删除主题色
const deleteThemeColor = (index: number) => {
  const props = {
    themeColor: themeColor.value.filter((c, i) => i !== index),
  }
  updateElement(props)
}

// 设置网格颜色
const updateGridColor = (gridColor: string) => {
  updateElement({ gridColor })
}

// 设置图例位置/不显示
const updateLegend = (legend: '' | 'top' | 'bottom') => {
  updateElement({ legend })
}

const openDataEditor = () => chartDataEditorVisible.value = true

emitter.on(EmitterEvents.OPEN_CHART_DATA_EDITOR, openDataEditor)
onUnmounted(() => {
  emitter.off(EmitterEvents.OPEN_CHART_DATA_EDITOR, openDataEditor)
})

return (_ctx: any,_cache: any) => {
  const _component_IconEdit = _resolveComponent("IconEdit")!
  const _component_IconCloseSmall = _resolveComponent("IconCloseSmall")!
  const _component_IconPlus = _resolveComponent("IconPlus")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(Button, {
      class: "full-width-btn",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (chartDataEditorVisible.value = true))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_IconEdit, { class: "btn-icon" }),
        _createTextVNode(" 编辑图表数据 ")
      ]),
      _: 1
    }),
    _createVNode(Divider),
    (_unref(handleChartElement).chartType === 'line')
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(Checkbox, {
              "onUpdate:value": _cache[1] || (_cache[1] = value => updateOptions({ showArea: value })),
              value: showArea.value,
              style: {"flex":"1"}
            }, {
              default: _withCtx(() => [
                _createTextVNode("面积图样式")
              ]),
              _: 1
            }, 8, ["value"]),
            _createVNode(Checkbox, {
              "onUpdate:value": _cache[2] || (_cache[2] = value => updateOptions({ showLine: value })),
              value: !showLine.value,
              style: {"flex":"1"}
            }, {
              default: _withCtx(() => [
                _createTextVNode("散点图样式")
              ]),
              _: 1
            }, 8, ["value"])
          ]),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(Checkbox, {
              "onUpdate:value": _cache[3] || (_cache[3] = value => updateOptions({ lineSmooth: value })),
              value: lineSmooth.value
            }, {
              default: _withCtx(() => [
                _createTextVNode("使用平滑曲线")
              ]),
              _: 1
            }, 8, ["value"])
          ])
        ], 64))
      : _createCommentVNode("", true),
    (_unref(handleChartElement).chartType === 'bar')
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createVNode(Checkbox, {
            "onUpdate:value": _cache[4] || (_cache[4] = value => updateOptions({ horizontalBars: value })),
            value: horizontalBars.value,
            style: {"flex":"1"}
          }, {
            default: _withCtx(() => [
              _createTextVNode("条形图样式")
            ]),
            _: 1
          }, 8, ["value"]),
          _createVNode(Checkbox, {
            "onUpdate:value": _cache[5] || (_cache[5] = value => updateOptions({ stackBars: value })),
            value: stackBars.value,
            style: {"flex":"1"}
          }, {
            default: _withCtx(() => [
              _createTextVNode("堆叠样式")
            ]),
            _: 1
          }, 8, ["value"])
        ]))
      : _createCommentVNode("", true),
    (_unref(handleChartElement).chartType === 'pie')
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createVNode(Checkbox, {
            "onUpdate:value": _cache[6] || (_cache[6] = value => updateOptions({ donut: value })),
            value: donut.value
          }, {
            default: _withCtx(() => [
              _createTextVNode("环形图样式")
            ]),
            _: 1
          }, 8, ["value"])
        ]))
      : _createCommentVNode("", true),
    _createVNode(Divider),
    _createElementVNode("div", _hoisted_6, [
      _hoisted_7,
      _createVNode(Select, {
        style: {"width":"60%"},
        value: legend.value,
        "onUpdate:value": _cache[7] || (_cache[7] = value => updateLegend(value as '' | 'top' | 'bottom')),
        options: [
          { label: '不显示', value: '' },
          { label: '显示在上方', value: 'top' },
          { label: '显示在下方', value: 'bottom' },
        ]
      }, null, 8, ["value"])
    ]),
    _createVNode(Divider),
    _createElementVNode("div", _hoisted_8, [
      _hoisted_9,
      _createVNode(Popover, {
        trigger: "click",
        style: {"width":"60%"}
      }, {
        content: _withCtx(() => [
          _createVNode(ColorPicker, {
            modelValue: fill.value,
            "onUpdate:modelValue": _cache[8] || (_cache[8] = value => updateFill(value))
          }, null, 8, ["modelValue"])
        ]),
        default: _withCtx(() => [
          _createVNode(ColorButton, { color: fill.value }, null, 8, ["color"])
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_10, [
      _hoisted_11,
      _createVNode(Popover, {
        trigger: "click",
        style: {"width":"60%"}
      }, {
        content: _withCtx(() => [
          _createVNode(ColorPicker, {
            modelValue: gridColor.value,
            "onUpdate:modelValue": _cache[9] || (_cache[9] = value => updateGridColor(value))
          }, null, 8, ["modelValue"])
        ]),
        default: _withCtx(() => [
          _createVNode(ColorButton, { color: gridColor.value }, null, 8, ["color"])
        ]),
        _: 1
      })
    ]),
    _createVNode(Divider),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(themeColor.value, (color, index) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "row",
        key: index
      }, [
        _createElementVNode("div", _hoisted_12, _toDisplayString(index === 0 ? '主题配色：' : ''), 1),
        _createVNode(Popover, {
          trigger: "click",
          style: {"width":"60%"}
        }, {
          content: _withCtx(() => [
            _createVNode(ColorPicker, {
              modelValue: color,
              "onUpdate:modelValue": value => updateTheme(value, index)
            }, null, 8, ["modelValue", "onUpdate:modelValue"])
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_13, [
              _createVNode(ColorButton, { color: color }, null, 8, ["color"]),
              (index !== 0)
                ? _withDirectives((_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "delete-color-btn",
                    onClick: _withModifiers(($event: any) => (deleteThemeColor(index)), ["stop"])
                  }, [
                    _createVNode(_component_IconCloseSmall)
                  ], 8, _hoisted_14)), [
                    [_directive_tooltip, '删除']
                  ])
                : _createCommentVNode("", true)
            ])
          ]),
          _: 2
        }, 1024)
      ]))
    }), 128)),
    _createVNode(ButtonGroup, {
      class: "row",
      passive: ""
    }, {
      default: _withCtx(() => [
        _createVNode(Popover, {
          trigger: "click",
          open: presetThemesVisible.value,
          "onUpdate:open": _cache[11] || (_cache[11] = ($event: any) => ((presetThemesVisible).value = $event)),
          style: {"width":"40%"}
        }, {
          content: _withCtx(() => [
            _createElementVNode("div", _hoisted_15, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(presetChartThemes, (item, index) => {
                return _createElementVNode("div", {
                  class: "preset-theme",
                  key: index
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item, (color, itemIndex) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: _normalizeClass(["preset-theme-color", { 'select': presetThemeColorHoverIndex.value[0] === index && itemIndex <= presetThemeColorHoverIndex.value[1] }]),
                      key: color,
                      style: _normalizeStyle({ backgroundColor: color }),
                      onClick: ($event: any) => (applyPresetTheme(item, itemIndex)),
                      onMouseenter: ($event: any) => (presetThemeColorHoverIndex.value = [index, itemIndex]),
                      onMouseleave: _cache[10] || (_cache[10] = ($event: any) => (presetThemeColorHoverIndex.value = [-1, -1]))
                    }, null, 46, _hoisted_16))
                  }), 128))
                ])
              }), 64))
            ])
          ]),
          default: _withCtx(() => [
            _createVNode(Button, {
              first: "",
              style: {"width":"100%"}
            }, {
              default: _withCtx(() => [
                _createTextVNode("推荐主题")
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["open"]),
        _createVNode(Button, {
          last: "",
          disabled: themeColor.value.length >= 10,
          style: {"width":"60%"},
          onClick: _cache[12] || (_cache[12] = ($event: any) => (addThemeColor()))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_IconPlus, { class: "btn-icon" }),
            _createTextVNode(" 添加主题色 ")
          ]),
          _: 1
        }, 8, ["disabled"])
      ]),
      _: 1
    }),
    _createVNode(Divider),
    _createVNode(ElementOutline),
    _createVNode(Modal, {
      visible: chartDataEditorVisible.value,
      "onUpdate:visible": _cache[15] || (_cache[15] = ($event: any) => ((chartDataEditorVisible).value = $event)),
      width: 640
    }, {
      default: _withCtx(() => [
        _createVNode(ChartDataEditor, {
          data: _unref(handleChartElement).data,
          onClose: _cache[13] || (_cache[13] = ($event: any) => (chartDataEditorVisible.value = false)),
          onSave: _cache[14] || (_cache[14] = value => updateData(value))
        }, null, 8, ["data"])
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}
}

})